import {Inline} from '@sanity/ui'
import {styled} from 'styled-components'

export const MenuActionsWrapper = styled(Inline)`
  position: absolute;
  top: 0;
  right: 0;
`
